import React from "react";
import TablaTargets from "js/pages/Unilever/Campana/Targets/Tabla";

function Targets(props) {
  return <TablaTargets />;
}

export default Targets;
